export const TITLE =
  "Euler Storm Ev: Best Price, Unbeatable offers - Buy Now at Turno";

export const META_NAME = "description";

export const META_CONTENT =
  "Discover the Euler Storm Ev at Turno. Check Treo auto price, features and specifications. Get a free test drive, assured financing and great deals only at Turno.";

export const META_KEYWORDS_NAME = "keywords";

export const META_KEYWORDS_CONTENT =
  "mahindra auto battery wala, treo auto price,mahindra electric auto, mahindra e rickshaw, e rickshaw price mahindra, mahindra treo on road price, mahindra electric auto showroom near me, mahindra auto rickshaw, mahindra electric auto price, mahindra electric 3 wheeler price, mahindra e rickshaw price on road, mahindra treo e rickshaw, mahindra electric auto price, mahindra e rickshaw price, mahindra electric auto, mahindra treo battery price, mahindra ev auto, mahindra electric vehicle, mahindra treo electric auto price, mahindra battery auto, mahindra electric auto showroom near me, mahindra battery auto price";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADER = "Highlights of Euler Storm Ev";

export const SUB_TEXT =
  "Euler’s most selling Storm EV packs a punch with its impressive torque, and a best in class load bearing capacity. You can avail this cargo EV at an affordable price. It offers lower operating costs than the conventional CNG or petrol alternatives available in the market. Choose an eco-friendly option that contributes to your savings and is helpful to the environment.";

export const BENEFITS_HEADER = "Benefits of Euler Storm Ev";

export const VEHICLE_FEATURE_HEADER = "Features of Euler Storm Ev";

export const BRAND_DEALER_HEADER = "Euler Storm Ev Showroom Near Me";

export const BRAND_DEALER_DESCRIPITION =
  "Turno is the home of the best EV vehicles that help your business prosper. You can avail better deals with Turno than any other brand dealership in your area. At Turno, we don’t only sell EVs, we also provide excellent after-sale support such as assured vehicle buyback, dedicated relationship manager, arranging roadside assistance and additional EV services.";

export const FAQ_HEADER_TEXT = "FAQs on Euler Storm Ev";

export const H1_HEADING = "Euler Storm EV";
